class TabException extends Error {}

export default TabException;
